import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import assignProps from "../../assignProps.mjs";
import useEnhancedEffect from "../../use/useEnhancedEffect.mjs";
import pick from "../../pick.mjs";
export var HOIST_CONTEXT = Symbol('HOIST_CONTEXT');
var HOIST_SELF = Symbol('HOIST_SELF');
var HOIST_SET = Symbol('HOIST_SET');
function flatChildComponent(childComponents) {
  return Object.values(childComponents).reduce(function (acc, Component) {
    if (Array.isArray(Component)) {
      acc = [].concat(_toConsumableArray(acc), [Component[0]], _toConsumableArray(flatChildComponent(Component[1])));
    } else {
      acc.push(Component);
    }
    return acc;
  }, []);
}

/** @deprecated Doesn't work in ssr and sometimes breakes rulles of hooks. We should never use it. */
function Enhancement(childComponents, Context) {
  return {
    condition: function condition(Component) {
      return [Component].concat(_toConsumableArray(flatChildComponent(childComponents))).some(function (Component) {
        var _Component$hoistProps;
        return Boolean((_Component$hoistProps = Component.hoistProps) === null || _Component$hoistProps === void 0 ? void 0 : _Component$hoistProps.length);
      });
    },
    init: function init(props, WrapperComponent, isFunction) {
      var _this = this;
      if (isFunction) {
        // TODO: might breake rules of hooks (by lsroman)
        this[HOIST_SELF] = React.useState({});
      } else {
        this[HOIST_SELF] = [{}, function (obj) {
          _this[HOIST_SELF][0] = obj;
          _this.forceUpdate();
        }];
      }
      // For optimization render
      this[HOIST_SET] = function (obj) {
        _this[HOIST_SELF][1](obj);
      };
    },
    context: function context(_context) {
      // TODO: need to optimizte container initialization (by lsroman)
      // WrapperComponent.hoistProps
      return _objectSpread(_objectSpread({}, _context), {}, _defineProperty({}, HOIST_CONTEXT, this[HOIST_SET]));
    },
    asProps: function asProps(props) {
      // TODO: need to check for no props overwriting (by lsroman)
      return assignProps(this[HOIST_SELF][0], props);
    },
    wrapperProps: function wrapperProps(props, WrapperComponent) {
      var _WrapperComponent$hoi;
      if ((_WrapperComponent$hoi = WrapperComponent.hoistProps) !== null && _WrapperComponent$hoi !== void 0 && _WrapperComponent$hoi.length) {
        var context = React.useContext(Context);
        var renameProps = WrapperComponent.hoistProps.reduce(function (acc, propName) {
          var _propName$split = propName.split(':'),
            _propName$split2 = _slicedToArray(_propName$split, 2),
            name = _propName$split2[0],
            rename = _propName$split2[1];
          acc[name] = rename || name;
          return acc;
        }, {});
        var hoistProps = Object.entries(pick(props, Object.keys(renameProps))).reduce(function (acc, _ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            value = _ref2[1];
          acc[renameProps[name]] = value;
          return acc;
        }, {});
        useEnhancedEffect(function () {
          if (context[HOIST_CONTEXT]) {
            context[HOIST_CONTEXT](hoistProps);
          }
        }, Object.values(hoistProps));
      }
      return props;
    }
  };
}
export default Enhancement;
//# sourceMappingURL=hoistProps.mjs.map